//by ziting
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-musite',
  templateUrl: './musite.component.html',
  styleUrls: ['./musite.component.css'],
})
export class MusiteComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
